import React from 'react';
import { useSelector } from 'react-redux';
import ChanceInfo from '../../../components/chancemng/info/ChanceInfo';

const ChanceInfoContainer = ({ handleGoBack }) => {
  const { chance } = useSelector(({ chanceModule }) => ({
    chance: chanceModule.chance.chance,
    
  }));

  return <ChanceInfo chance={chance}  handleGoBack={handleGoBack} />;
};

export default ChanceInfoContainer;
